<template>
	<div>
		<Navigation />
		<div class="content mt-4">
			<div class="container">
				<div class="row">
					<div class="col-4 mt-5">
						<span class="section-title">Current Plan</span>
						<div class="block plan">
							<span class="plan--title current">{{plan[0].name}}</span>
							<hr style="border-color: gray;" />
							<p class="plan--description" v-html="planDescription(plan[0].name)"></p>
						</div>
						<div>
							<div class="page-block--title"></div>
						</div>
					</div>
					<div class="col-4 mt-5">
						<div class="page-block--title">Betalingen</div>
						<div class="block payment">
							<span class="plan--title" style="color: black !important; font-weight: 600; font-size: 1em;">Laatste betaling</span>
							<br />
							<p class="plan--description" v-html="''"></p>
						</div>
					</div>
					<div class="col-4 mt-5">
						<div class="page-block--title"> </div>
						<div class="block payment">
							<span class="plan--title" style="color: black !important; font-weight: 600; font-size: 1em;">Volgende betaling</span>
							<br />
							<p class="plan--description" v-html="''"></p>
						</div>
					</div>
				</div>
				<div class="row">
					<div class="col-8">
						<span class="section-title">Plans</span>
					</div>
					<div class="col-4"></div>
				</div>
				<div class="row">
					<div class="col-4" v-for="plan in plans" :key="plan.id">
						<div class="block plan">
							<span class="plan--title">{{plan.name}} - {{plan.gross_price}}</span>
							<hr style="border-color: gray;" />
							<p class="plan--description" v-html="planDescription(plan.name)"></p>
							<div  class="button--standard" @click="checkout(plan.id)">Upgrade</div>
						</div>
						<div>
							<div class="page-block--title"></div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>


<script>
	import axios from "axios";
	export default {
		name: "Billing",
		components: {},
		computed: {},
		methods: {
			setInnerHTML(elm, html) {
				elm.innerHTML = html;
				Array.from(elm.querySelectorAll("script")).forEach(oldScript => {
					const newScript = document.createElement("script");
					Array.from(oldScript.attributes)
						.forEach(attr => newScript.setAttribute(attr.name, attr.value));
					newScript.appendChild(document.createTextNode(oldScript.innerHTML));
					oldScript.parentNode.replaceChild(newScript, oldScript);
				});
			},
			planDescription(name) {
				if (name == "Basic") {
					return "- Design your contest page. <br /> - 1 active contest <br /> - Demo management";
				} else if (name == "Premium") {
					return "- Email notifications. <br /> - 3 active contests <br />";
				} else if (name == "Pro") {
					return "- Custom domain <br /> - 10 active contests";
				} else {
					return "";
				}
			},
			getPlans() {
				var self = this;

				axios({
						method: "GET",
						crossdomain: true,
						headers: {
							"Content-Type": "Content-Type:application/json"
						},
						url: "/subscription/packages",
					})
					.then(function(response) {
						console.log(response);
						self.plans = response.data;
					})
					.catch(function(error) {
						self.errors = error.response.data;
						self.isLoading = false;
					});
			},
			checkout(id) {
				var self = this;

				axios({
						method: "GET",
						crossdomain: true,
						headers: {
							"Content-Type": "Content-Type:application/json"
						},
						url: "/subscription/checkout?package_id=" + id,
					})
					.then(function(response) {
						console.log(response);
						window.location = response.data;
					})
					.catch(function(error) {
						self.errors = error.response.data;
						self.isLoading = false;
					});


			}
		},
		mounted() {

			this.getPlans();
			
			var self = this;
			this.$store.dispatch('getPlan', {
				})
				.then(() => {
					console.log(this.$store.state);
					self.isLoading = false;
					var self2 = this;
					var currentPlan = self.plans.filter(obj => {
						return obj.id === self2.$store.state.plan;
					})
					self.plan = currentPlan;
					
				})
				.catch(err => {
					console.log(err.response);
				})
		},
		data() {
			return {
				checkoutButton: null,
				plans: [],
				plan: 'Loading..',
				lastPayment: {},
				nextPayment: {},
			};
		},
	};
</script>